module.exports = __webpack_public_path__ + "eab41b772f9aa36a8d71db121a0a7768.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_0_0.woff2
// module id = 2246
// module chunks = 2